import { render, staticRenderFns } from "./BasicTextSection.vue?vue&type=template&id=6c6e0c92&scoped=true&"
import script from "./BasicTextSection.vue?vue&type=script&lang=js&"
export * from "./BasicTextSection.vue?vue&type=script&lang=js&"
import style0 from "./BasicTextSection.vue?vue&type=style&index=0&id=6c6e0c92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6e0c92",
  null
  
)

export default component.exports